import { Component, OnInit } from '@angular/core';
import { SettingsService, AuthService, FirestoreService } from '../../services/service.index';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit  {

  user:any;

  constructor(private _ajustes: SettingsService, public authService: AuthService, private firestorService: FirestoreService) {

  }


  ngOnInit(){

    this.user = this.firestorService.usersShow;

    if(this.user.img == '' || this.user.img == undefined){
        this.user.img = '../assets/img/images.jpeg';
    }

  }

  ngAfterViewInit(): void {
    this._ajustes.cargarAjustes();
  }



}
